import {sprintf} from 'sprintf-js';
import JobCorpsCenter from '@/classes/JobCorpsCenter';
import store from '@/store';

interface IStudentProfile {
    id?: number;
    dolId?: string;
    firstName?: string;
    middleName?: string;
    lastName?: string;
    suffix?: string;
    certificationDate?: string | null;
    jobCorpsCenter?: JobCorpsCenter;
    jobCorpsCenterId?: number;
    active?: boolean;
    studentStatusDate?: string;
    certificates?: number[];
}

class StudentProfile implements IStudentProfile {

    public id?: number;
    public dolId?: string;
    public firstName?: string;
    public middleName?: string;
    public lastName?: string;
    public suffix?: string;
    public certificationDate?: string | null;
    public jobCorpsCenterId?: number;
    public jobCorpsCenter?: JobCorpsCenter;
    public active?: boolean;
    public studentStatusDate?: string;
    public certificates: number[];

    public formattedName?: string;

    constructor(s: IStudentProfile = {}) {
        this.id = s.id;
        this.dolId = s.dolId;
        this.firstName = s.firstName;
        this.middleName = s.middleName;
        this.lastName = s.lastName;
        this.suffix = s.suffix;
        this.jobCorpsCenterId = s.jobCorpsCenterId;
        this.jobCorpsCenter = this.getJobCorpsCenter();
        this.active = s.active;
        this.studentStatusDate = s.studentStatusDate;
        this.certificates = s.certificates || [];

        this.formattedName = this.getFullName();
        this.certificationDate = null;
    }

    public getFullName(): string {
        return sprintf('%s%s %s%s',
            !this.firstName ? '' : this.firstName,
            !this.middleName ? '' : ' ' + this.middleName,
            !this.lastName ? '' : ' ' + this.lastName,
            !this.suffix ? '' : ' ' + this.suffix
        ).trim();
    }

    public getJobCorpsCenter() {
        return store.getters.getJobCorpsCenterById(this.jobCorpsCenterId);
    }

    public toString(): string {
        return this.getFullName();
    }

    public setActive(active?: boolean, statusDate?: string): void {
        this.active = active;
        this.studentStatusDate = statusDate;
    }

    public clone(): StudentProfile {
        return new StudentProfile({
            id: this.id,
            dolId: this.dolId,
            firstName: this.firstName,
            middleName: this.middleName,
            lastName: this.lastName,
            suffix: this.suffix,
            jobCorpsCenterId: this.jobCorpsCenterId,
            active: this.active,
            certificates: this.certificates
        });
    }
}

export default StudentProfile;
export { StudentProfile, IStudentProfile };
